import { useState } from 'react'
import { COLUMNAS_INICIALES, COLUMNAS_POSIBLES, type Columnas } from './medidas'

const CLAVE = 'rastro:columnas-grilla'

const leer = (): Columnas => {
  try {
    const n = Number(localStorage.getItem(CLAVE))
    return (COLUMNAS_POSIBLES as readonly number[]).includes(n)
      ? (n as Columnas)
      : COLUMNAS_INICIALES
  } catch {
    return COLUMNAS_INICIALES
  }
}

/**
 * Columnas de la grilla de escritorio (DEC-08): arranca en 6 y cada
 * computadora recuerda la que se eligió. Es una comodidad de quien mira, no
 * un dato del proyecto: si el navegador no guarda, vuelve a 6.
 */
export function useColumnas() {
  const [columnas, setColumnas] = useState<Columnas>(leer)
  const cambiar = (n: Columnas) => {
    setColumnas(n)
    try {
      localStorage.setItem(CLAVE, String(n))
    } catch {
      // Sin almacenamiento: vale para esta visita.
    }
  }
  return [columnas, cambiar] as const
}
